import { render, staticRenderFns } from "./VideoViews.vue?vue&type=template&id=7320af38&scoped=true"
import script from "./VideoViews.vue?vue&type=script&lang=js"
export * from "./VideoViews.vue?vue&type=script&lang=js"
import style0 from "./VideoViews.vue?vue&type=style&index=0&id=7320af38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7320af38",
  null
  
)

export default component.exports